import {
  IBenefitsAndDesiredOutcomes,
  IDocumentData,
  IInvestmentNeedsPolicyIncentives,
  IJustification,
  IKeyBusinessDrivers,
  IMarketSizeAndDemandAnalysis,
  IObjectives,
  IProjectScope,
  ISectorSpecificAnalysis,
  ISocioEconomicContext,
  IStrategicFitSummaryDashboard,
  IStrategicFuturesAndResilienceTesting,
  IStrategicSignificanceImpactFramework,
  ISupplementaryInfrastructurePlanning,
  ISWOTAnalysis,
  ITechnicalOptionsAnalysis,
} from "./_models";

const formMeta = {
  formAction: "",
  iscompleted: false,
};

interface defaultValuesTypes {
  project_scope: IProjectScope;
  justification: IJustification;
  objectives: IObjectives;
  supplementary_infrastructure_planning: ISupplementaryInfrastructurePlanning;
  strategic_significance_impact_framework: IStrategicSignificanceImpactFramework;
  sector_specific_analysis: ISectorSpecificAnalysis;
  market_size_and_demand_analysis: IMarketSizeAndDemandAnalysis;
  benefits_and_desired_outcomes: IBenefitsAndDesiredOutcomes;
  investment_needs_policy_incentives: IInvestmentNeedsPolicyIncentives;
  strategic_fit_summary_dashboard: IStrategicFitSummaryDashboard;
  socio_economic_context: ISocioEconomicContext;
  swot_analysis: ISWOTAnalysis;
  key_business_drivers: IKeyBusinessDrivers;
  documents: IDocumentData;
  technical_options_analysis: ITechnicalOptionsAnalysis;
  strategic_futures_and_resilience_testing: IStrategicFuturesAndResilienceTesting;
  sg1_validation_rule: any;
  approval_submit: any;
}

export const infrastructurePlanningDefaultValues: defaultValuesTypes = {
  project_scope: {
    provinces: 0,
    is_land_identified: "",
    is_land_ownership_confirmed: "",
    is_zoning_compliant: "",

    planning_start_date: null,
    completion_end_date: null,

    construction_duration_years: 0,
    construction_duration_months: 0,
    operations_duration_years: 0,
    operations_duration_months: 0,
    infrastructure_sector: "",
    delivery_model_initial: [],

    infrastructure_type: [],
    infrastructure_type_remarks: {},
    infrastructure_output_type: "",
    service_level: "",
    capacity: "",

    institutional_sponsors: [],
    stakeholder_coordination_plan: "",
    signed_agreements: [],

    strategic_alignment_frameworks: [],
    programme_alignment: "",
    related_projects: [],

    fiscal_request_bfi: "no",
    fiscal_request_reason: "",

    estimated_cost_min: 0,
    estimated_cost_max: 0,
    basis_of_estimate: [],

    ...formMeta,
  },

  justification: {
    problem_statement: "",
    affected_population: [],
    affected_population_remarks: {},
    severity_level: "",
    consequences_of_no_action: "",
    existing_services_baseline: "",
    justification_quantified_status_quo: "",

    current_demand: "",
    future_demand_growth_rate: "",
    future_demand_growth_description: "",
    supply_demand_gap: "",
    forecast_horizon: "",
    demand_data_sources: [],

    ...formMeta,
  },

  objectives: {
    project_objectives_areas: [],
    project_outcomes: [],
    smart_indicators: [],
    ...formMeta,
  },

  supplementary_infrastructure_planning: {
    supplementary_infrastructure_requirements: "",
    ...formMeta,
  },

  strategic_significance_impact_framework: {
    strategic_infrastructure_rationale: "",
    alignment_with_national_infrastructure_priorities: "",
    contribution_to_economic_development: "",
    long_term_strategic_significance: "",
    contribution_to_regional_national_development: "",
    national_provincial_strategy_alignment: [],
    alignment_evidence: "",
    mandate_delivery: "",
    legal_mandates_obligations: [],
    national_alignment: "",
    urgent_challenges: [],
    challenge_context: "",
    service_delivery_improvements: [],
    service_improvement_metrics: "",
    institutional_systemic_changes: [],
    transformation_plan: "",
    economic_impact_areas: [],
    job_creation_estimate: "",
    evidence_data_sources: [],
    psp_strategic_objectives: "",
    growth_and_jobs_agenda: "",
    ndp_alignment: "",
    smme_strategy_alignment: "",
    sez_economic_zone_priorities: "",
    ...formMeta,
  },

  sector_specific_analysis: {
    sector_trends: "",
    institutional_context: "",
    capacity_constraints: "",
    regulatory_environment: "",

    ...formMeta,
  },

  market_size_and_demand_analysis: {
    market_size: "",
    target_market: "",
    market_growth_rate: "",
    market_gap: "",
    market_assumptions: "",

    ...formMeta,
  },

  benefits_and_desired_outcomes: {
    benefit_outcomes: {},

    ...formMeta,
  },

  investment_needs_policy_incentives: {
    funding_requirements: "",
    economic_rationale: "",
    public_sector_intervention_justification: "",
    grants_incentives_support_programmes: "",
    expected_economic_social_returns: "",

    ...formMeta,
  },

  strategic_fit_summary_dashboard: {
    alignment_with_organisational_priorities: "",
    alignment_with_sector_plan: "",
    alignment_with_development_strategies: "",
    strategic_contribution: "",

    ...formMeta,
  },

  socio_economic_context: {
    economic_context: "",
    economic_gis_datasets: "",
    social_context: "",
    social_gis_datasets: "",
    environmental_context: "",
    environmental_gis_datasets: "",
    infrastructure_baseline: "",
    infrastructure_gis_datasets: "",
    distribution_effects: "",
    distribution_gis_datasets: "",

    ...formMeta,
  },

  swot_analysis: {
    swot_strengths: [],
    swot_weaknesses: [],
    swot_opportunities: [],
    swot_threats: [],
    swot_strategic_positioning_feasibility_link: "",

    ...formMeta,
  },

  key_business_drivers: {
    business_case_drivers: [],
    business_case_drivers_remarks: {},

    ...formMeta,
  },

  documents: {
    documents: [],

    ...formMeta,
  },

  technical_options_analysis: {
    technical_preferred_option_selected: "",
    technical_preferred_option: "",
    ...formMeta,
  },

  strategic_futures_and_resilience_testing: {
    resilience_justification: "",
    optimistic_benefits: "",
    optimistic_costs: "",
    optimistic_justification: "",
    mostlikely_benefits: "",
    mostlikely_costs: "",
    mostlikely_justification: "",
    pessimistic_benefits: "",
    pessimistic_costs: "",
    pessimistic_justification: "",
    risk_mitigation_prevent: "",
    risk_mitigation_avoid: "",
    risk_mitigation_transfer: "",
    risk_mitigation_accept: "",
    documents: [],
    ...formMeta,
  },

  sg1_validation_rule: {},

  approval_submit: {},
};

export type IInfrastructurePlanningFormValues =
  typeof infrastructurePlanningDefaultValues;
